import React, { useEffect, useState } from 'react';
import { Box, Typography, TablePagination, useTheme, Button } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import GenericTable from '../common/GenericTable';
import { useNotification } from '../../context/NotificationContext';
import { EditOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { userService } from '../../services/user';
import { getUserInfo } from '../../services/authApis';

const AddressBook = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [addressData, setAddressData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(1);
  const theme = useTheme();
  const addNotification = useNotification();

 // Fetch the user object from localStorage
 useEffect(() => {
  const fetchUserData = async () => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      try {
        const response = await getUserInfo();
        // console.log("Full API response:", response);
        
        if (response) {
          const formattedData = [response]; 
          // console.log("Formatted data for table:", formattedData);
          setAddressData(formattedData);
          setTotalRecords(1);
        } else {
          setAddressData([]);
          setTotalRecords(0);
        }
      } catch (error) {
        console.error("Error fetching user details:", error);
        setAddressData([]);
        setTotalRecords(0);
      }
    }
  };

  fetchUserData();
}, []);


const navigate=useNavigate();
  // Column definitions for the table
  const columns = [
    {
      label: 'Address',
      field: 'name', // Use a field that exists in your data as the base field
      render: (value, row) => (
        <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
          {row.name || `${row.first_name || ''} ${row.last_name || ''}`.trim()}
          {row.business_name ? `\n${row.business_name}` : ''}
          {row.address_1 ? `\n${row.address_1}` : ''}
          {row.address_2 ? `\n${row.address_2}` : ''}
          {row.city || row.region_state || row.post_code ? 
            `\n${row.city || ''}${row.city && row.region_state ? ', ' : ''}${row.region_state || ''} ${row.post_code || ''}`.trim() 
            : ''}
          {row.country ? `\n${row.country}` : ''}
          {row.county ? `\n ${row.county}` : ''}
        </Typography>
      ),
    },
  ];
  
 
 const actions = [
  {
    icon: <EditOutlined />,
    onClick: (row) => handleEdit(row),
    style: { backgroundColor: '#808080', minWidth: '40px', padding: '6px' }
  },
  
  ]

  // Handle Edit action
  const handleEdit = (row) => {
    // addNotification('info', `Editing address for ${row.first_name} ${row.last_name}`);
    navigate("/my/edit-account")
  };

  // Handle Delete action
  const handleDelete = (row) => {
    addNotification('success', `Deleted address for ${row.first_name} ${row.last_name}`);
    setAddressData([]);
    setTotalRecords(0);
  };

  // Handle pagination changes
  const handlePageChange = (event, newPage) => setPage(newPage);
  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  

  return (
    <Box
      sx={{
        mt: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        width: '100%',
      }}
    >
      <Typography
        variant="h4"
        sx={{
          color: theme.palette.heading_color.main,
          fontWeight: 600,
          fontSize: { xs: 20, sm: 24 },
        }}
      >
        Address Book Entries
      </Typography>

      {/* Reusable Table */}
      <GenericTable
  columns={columns}
  data={addressData}
  loading={false}
  actions={actions}
  renderActions={() => true} // Always render actions
/>


      {/* Pagination */}
      <TablePagination
        component="div"
        count={totalRecords}
        page={page}
        onPageChange={handlePageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleRowsPerPageChange}
      />
    </Box>
  );
};

export default AddressBook;
